import React, { useEffect } from 'react'
import { freshService } from '../services/freshService'

export const useLoadFreshData = (
  ticketType: string,
  freshAccount: FreshAccount,
  setFreshError: React.Dispatch<React.SetStateAction<boolean>>,
  setServiceRequestData?: React.Dispatch<React.SetStateAction<any>>,
  setTicketFieldsData?: React.Dispatch<React.SetStateAction<any>>,
  setInitialAgentOptions?: React.Dispatch<React.SetStateAction<any>>
): void => {
  useEffect(() => {
    loadFreshData()
  }, [])

  const loadFreshData = async () => {
    try {
      if (setTicketFieldsData) {
        const ticketFieldsData: TicketFieldsData[] = await freshService.getFreshFields(freshAccount)
        setTicketFieldsData(ticketFieldsData)
        // if(setInitialAgentOptions) {

        const agent = ticketFieldsData.find((ticketFields: TicketFieldsData) => ticketFields.name === 'agent')
        setInitialAgentOptions && setInitialAgentOptions(agent?.options)
        // }
      }

      if (setServiceRequestData && ticketType === 'serviceRequest') {
        const categories = await freshService.getFreshData('categories', freshAccount, null)
        setServiceRequestData((serviceData: ServiceRequestFields) => ({
          ...serviceData,
          categories,
        }))
      }
    } catch (err) {
      if (err) {
        console.log('file: useLoadFreshData.tsx -> line 36 -> loadFreshData -> err', err)
        setFreshError(true)
      }
    }
  }
}
